import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'arrow-elbow-right',
  'IconArrowElbowRight',
  [
    ['path', { d: 'M21 14v-6h-6', key: 'svg-0' }],
    ['path', { d: 'M21 8l-9 9l-9 -9', key: 'svg-1' }],
  ],
);
